import { appendCurrentParamsToUrl } from '@web/helpers/routing';
import { LoaderFunction, redirect } from 'react-router';

export const loader: LoaderFunction = ({ request }) => {
  const url = appendCurrentParamsToUrl(new URL(request.url), '/leave-approvals/todo');
  return redirect(url);
};
